var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureTileIcon05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#E3EFE3;}\r\n\t.st2{display:inline;}\r\n\t.st3{fill:#D7DDDD;}\r\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:8;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.26,
    y: 17.26,
    className: "st1",
    width: 29.48,
    height: 29.48
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2_00000052095696074617559010000005859981156795778233_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2_00000098197705911788952850000017416751865890436489_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.01,
    y: 19.12,
    className: "st3",
    width: 27.96,
    height: 27.96
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M31.25,25.18c0.67,0.79,1.86,0.89,2.65,0.22l1.94-1.82c0.72-0.76,0.69-1.93-0.05-2.66l-1.11-1.19 c-0.88-1.02-2.35-1.29-3.54-0.66c-4.75,2.8-8.83,6.61-11.92,11.18c-0.71,1.14-0.53,2.62,0.42,3.57l1.11,1.19 c0.67,0.79,1.86,0.89,2.65,0.22l1.94-1.82c0.72-0.76,0.69-1.93-0.05-2.66l-0.67-0.72c1.78-2.07,3.78-3.94,5.95-5.58L31.25,25.18z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M44.63,41.96l-6.04-11.03c-0.46-0.86-1.52-1.19-2.39-0.74c-0.32,0.16-0.58,0.42-0.74,0.74l-6.04,11.03 c-0.48,0.88-0.15,1.98,0.72,2.47c0.27,0.15,0.57,0.22,0.87,0.22h12.02c1.01,0,1.81-0.82,1.81-1.81 C44.85,42.52,44.77,42.22,44.63,41.96z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 37.02,
    y1: 34.36,
    x2: 37.02,
    y2: 37.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 37.02,
    cy: 41.02,
    r: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTileIcon05);
export default __webpack_public_path__ + "static/media/feature-tile-icon-05.92b4bcca534d9471ebdedbd3d8614df0.svg";
export { ForwardRef as ReactComponent };